import { styled } from '@mui/material'
import { NavLink } from 'react-router-dom'

export const StyledNavLink = styled(NavLink)(({ theme }) => ({}))
